// extracted by mini-css-extract-plugin
module.exports = {"reportStyle":"_19T7Cn0CQvvJjrSVV-wTkG"};